/**
 *
 * AddSuperGroup
 *
 */

import React from 'react';
import { TopActionButton } from 'app/components/BasicButtons/TopActionButton';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';

interface AddSuperGroupProps {}

export function AddSuperGroup(props: AddSuperGroupProps): JSX.Element {
  const { t } = useTranslation();

  //RENDER
  return (
    <React.Fragment>
      <TopActionButton
        target="_blank"
        variant="white"
        startIcon="plus"
        icon="plus"
        key={'newsupergroup'}
        text={t(translations.CreateNew)}
        href={{ search: {}, path: '/NewSuperGroup.aspx' }}
      />
      ,
    </React.Fragment>
  );
}
